/**
 * Formatting helpers for LaunchRocketButton / billing estimate UI.
 * Per-doc raw USD rates live on langchain_workflows.estimated_raw_usd_per_doc
 * (server-side). The client only sends file_count.
 */

/**
 * Compact numeric label for the rocket button (matches prior "0.0" / "2905.4" style).
 * @param {number} amount
 * @param {string} currency
 */
export function formatCompactBillingAmount(amount, currency) {
  const value = Number(amount)
  if (!Number.isFinite(value)) return "—"
  if (currency === "deepdocs_unit") {
    return Math.round(value).toLocaleString()
  }
  if (currency === "usd" || currency === "eur") {
    return value.toFixed(2)
  }
  return String(value)
}
